export default __webpack_public_path__ + "static/media/chevron-right.ecbfc212.svg";